import React from "react";
import Recompensas from "../../pages/recompensas/Recompensas";

const prefix = process.env.REACT_APP_PREFIX;

const recompensasRoutes = [
  {
    path: `${prefix}/utilidade/recompensas/Recompensas`,
    component: <Recompensas />,
    title: "recompensas",
  },
];

export default recompensasRoutes;
